var ExitMeetingPageController = /** @class */ (function () {
    /*@ngInject*/
    function ExitMeetingPageController() {
    }
    ExitMeetingPageController.prototype.$onInit = function () {
        this.$stateParams = this.$transition$.params();
    };
    return ExitMeetingPageController;
}());
export { ExitMeetingPageController };
// import * as TEMPLATE from './exit-meeting-page.html';
import * as TEMPLATE from 'raw-loader!./exit-meeting-page.html';
export var ExitMeetingPageComponent = {
    selector: 'exitMeetingPage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/exitMeeting/exit-meeting-page.html',
        template: TEMPLATE.default,
        controller: ExitMeetingPageController
    }
};
//# sourceMappingURL=exit-meeting-page.component.js.map